import { GlassCard } from "./GlassCard";

const Highlight = ({ text, query }) => {
  if (!query) return text;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx)}
      <mark className="rounded-sm bg-white/25 text-paper-100">{text.slice(idx, idx + query.length)}</mark>
      {text.slice(idx + query.length)}
    </>
  );
};

export const CommandCard = ({ command, query = "", testId }) => (
  <GlassCard className="flex h-full flex-col p-6" data-testid={testId}>
    <div className="flex items-start justify-between gap-3">
      <h3 className="break-all font-mono text-sm font-semibold text-paper-100">
        <Highlight text={command.name} query={query} />
      </h3>
      <div className="flex shrink-0 flex-col items-end gap-1.5">
        <span className="rounded-full border border-white/10 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-paper-500">
          {command.category}
        </span>
        <span className="font-mono text-[10px] uppercase tracking-wider text-paper-500/70">
          {command.type}
        </span>
      </div>
    </div>
    <p className="mt-3 flex-1 text-sm leading-relaxed text-paper-400">{command.description}</p>
    <div className="mt-5 space-y-2 border-t border-white/5 pt-4">
      <p className="break-all font-mono text-xs text-paper-500">
        <span className="text-paper-500/70">Usage </span>
        <span className="text-paper-200">{command.usage}</span>
      </p>
      {command.aliases?.length > 0 && (
        <p className="font-mono text-xs text-paper-500">
          <span className="text-paper-500/70">Aliases </span>
          {command.aliases.join(", ")}
        </p>
      )}
    </div>
  </GlassCard>
);
